import { EndpointReponseProps } from "../../types";

const baseURL = `${process.env.REACT_APP_BASE_URL}/api`;
// const baseURL = "http://localhost:8080/api";
export const Endpoints = {
  // Health Check
  GetCheckServerHealth: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/health/`,
      method: "GET",
    };
  },

  // Authentication
  GetLogin: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/auth/login/`,
      method: "POST",
    };
  },
  GetRegister: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/auth/users/`,
      method: "POST",
    };
  },
  GetForgotPassword: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/auth/password-reset-request/`,
      method: "POST",
    };
  },
  GetResetPassword: (token: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/auth/password-reset/${token}/`,
      method: "POST",
    };
  },
  GetVerifyEmail: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/auth/verify-email/`,
      method: "POST",
    };
  },
  GetRefreshToken: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/auth/refresh/`,
      method: "POST",
    };
  },

  // User/Profile
  GetCurrentUser: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/auth/user-detail/`,
      method: "GET",
    };
  },
  UpdateProfile: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/auth/user-detail/`,
      method: "PUT",
    };
  },
  PatchProfile: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/auth/user-detail/`,
      method: "PATCH",
    };
  },
  // Lawyers (for profile updates with documents)
  GetLawyer: (id: string | number): EndpointReponseProps => {
    return {
      route: `${baseURL}/lawyers/${id}/`,
      method: "GET",
    };
  },
  UpdateLawyer: (id: string | number): EndpointReponseProps => {
    return {
      route: `${baseURL}/lawyers/${id}/`,
      method: "PUT",
    };
  },
  CreateLawyer: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/lawyers/`,
      method: "POST",
    };
  },

  // Dashboard (Note: Not in Postman collection - may need to be added)
  GetDashboardStats: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/reports/transactions/`, // Using transactions as fallback
      method: "GET",
    };
  },

  // Transactions (Reports)
  GetTransactions: (params?: {
    page?: number;
    search?: string;
  }): EndpointReponseProps => {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.append("page", params.page.toString());
    if (params?.search) queryParams.append("search", params.search);
    const query = queryParams.toString();
    return {
      route: `${baseURL}/reports/transactions/${query ? `?${query}` : ""}`,
      method: "GET",
    };
  },
  GetTransactionDetail: (id: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/reports/transactions/${id}/`,
      method: "GET",
    };
  },
  CreateTransaction: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/reports/transactions/`,
      method: "POST",
    };
  },
  UpdateTransaction: (id: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/reports/transactions/${id}/`,
      method: "PUT",
    };
  },
  GetTransactionCertificate: (id: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/reports/transactions/${id}/certificate/`,
      method: "GET",
    };
  },

  // Deals
  GetDeals: (params?: {
    page?: number;
    search?: string;
  }): EndpointReponseProps => {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.append("page", params.page.toString());
    if (params?.search) queryParams.append("search", params.search);
    const query = queryParams.toString();
    return {
      route: `${baseURL}/deals/${query ? `?${query}` : ""}`,
      method: "GET",
    };
  },
  GetDealDetail: (id: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/deals/${id}/`,
      method: "GET",
    };
  },
  CreateDeal: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/deals/`,
      method: "POST",
    };
  },
  UpdateDeal: (id: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/deals/${id}/`,
      method: "PUT",
    };
  },
  DeleteDeal: (id: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/deals/${id}/`,
      method: "DELETE",
    };
  },

  // Documents (Note: Not in Postman collection - may need to be added)
  // Documents might be part of deals or transactions
  GetDocuments: (params?: {
    page?: number;
    search?: string;
  }): EndpointReponseProps => {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.append("page", params.page.toString());
    if (params?.search) queryParams.append("search", params.search);
    const query = queryParams.toString();
    return {
      route: `${baseURL}/deals/${query ? `?${query}` : ""}`, // Using deals as fallback
      method: "GET",
    };
  },
  GetDocumentDetail: (id: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/deals/${id}/`, // Using deals as fallback
      method: "GET",
    };
  },
  UploadDocument: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/deals/`, // Documents uploaded with deals
      method: "POST",
    };
  },
  DeleteDocument: (id: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/deals/${id}/`,
      method: "DELETE",
    };
  },
  DownloadDocument: (id: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/deals/${id}/`,
      method: "GET",
    };
  },
  GetTransactionDocuments: (transactionId: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/reports/transactions/${transactionId}/`,
      method: "GET",
    };
  },
  UploadTransactionDocument: (transactionId: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/reports/transactions/`,
      method: "POST",
    };
  },

  // Payments
  GetPayments: (params?: {
    page?: number;
    search?: string;
  }): EndpointReponseProps => {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.append("page", params.page.toString());
    if (params?.search) queryParams.append("search", params.search);
    const query = queryParams.toString();
    return {
      route: `${baseURL}/payments/${query ? `?${query}` : ""}`,
      method: "GET",
    };
  },
  GetPaymentDetail: (id: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/payments/${id}/`,
      method: "GET",
    };
  },
  GetPaymentStats: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/payments/`, // Stats might be calculated from payments list
      method: "GET",
    };
  },
  UpdatePayment: (id: string | number): EndpointReponseProps => {
    return {
      route: `${baseURL}/payments/${id}/`,
      method: "PUT",
    };
  },
  PatchPayment: (id: string | number): EndpointReponseProps => {
    return {
      route: `${baseURL}/payments/${id}/`,
      method: "PATCH",
    };
  },
  DeletePayment: (id: string | number): EndpointReponseProps => {
    return {
      route: `${baseURL}/payments/${id}/`,
      method: "DELETE",
    };
  },
  CreatePayment: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/payments/`,
      method: "POST",
    };
  },

  // KYC/Transaction Steps (Note: Not in Postman collection - may need to be added)
  // These might be part of deals creation flow
  GetBranches: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/lawyers/`, // Using lawyers as fallback - branches might be in lawyer data
      method: "GET",
    };
  },
  SubmitKYCStep1: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/deals/`, // KYC might be part of deal creation
      method: "POST",
    };
  },
  SubmitKYCStep2: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/deals/`,
      method: "POST",
    };
  },
  SubmitKYCStep3: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/deals/`,
      method: "POST",
    };
  },
  SubmitKYCStep4: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/deals/`,
      method: "POST",
    };
  },
  SubmitKYCStep5: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/deals/`,
      method: "POST",
    };
  },
  SubmitKYCStep6: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/deals/`,
      method: "POST",
    };
  },
  SubmitKYCStep7: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/deals/`,
      method: "POST",
    };
  },
  GetKYCStatus: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/deals/`,
      method: "GET",
    };
  },

  // Certificates (Note: Not in Postman collection - may need to be added)
  GetCertificate: (id: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/reports/transactions/${id}/`, // Certificate might be part of transaction
      method: "GET",
    };
  },
  DownloadCertificate: (id: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/reports/transactions/${id}/`,
      method: "GET",
    };
  },

  // Additional endpoints from Postman collection
  GetAnalyticsLogs: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/reports/analytics-logs/`,
      method: "GET",
    };
  },
  CreateAnalyticsLog: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/reports/analytics-logs/`,
      method: "POST",
    };
  },
  GetAuditLogs: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/auditlogs/`,
      method: "GET",
    };
  },
  CreateAuditLog: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/auditlogs/`,
      method: "POST",
    };
  },
  ContactSupport: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/auth/support/`,
      method: "POST",
    };
  },
  RegenerateVerificationCode: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/auth/verify-email/`,
      method: "POST",
    };
  },
};
